import features from '../common/features';
import { has, isFunction } from 'lodash';

function defaultSummaryTitle(seatData, disableRowTitle = false) {
  let parts = [];
  if (has(seatData, 'short_desc')) {
    parts.push(seatData.short_desc);
  }
  if (has(seatData, 'seat_row') && !disableRowTitle) {
    parts.push(`Row ${seatData.seat_row}`);
  }
  if (has(seatData, 'seat_num')) {
    parts.push(`Seat ${seatData.seat_num}`);
  }

  return parts.join(', ');
}

export default function summaryTitle(seatData, customiserFn = null, disableRowTitle = false) {
  customiserFn =
    customiserFn || features.getOption('customSeatDescription', 'customiser');

  if (isFunction(customiserFn)) {
    return customiserFn.call(null, seatData, disableRowTitle);
  } else {
    return defaultSummaryTitle(seatData, disableRowTitle);
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/summaryTitle.js